import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { CimaCore, Util, XmStore, XmStoreUtil } from 'core/services';
import { Subscription } from 'rxjs';
import { CmsCore, CmsDataDetail } from 'store/cms/models';
import { User } from 'store/user/models';
import { LineSummary } from 'store/account-summary/models';
import { BroadbandLabels } from 'store/broadband-label/models';
import { AccountType } from 'core/constants';

@Component({
    selector: 'cbm-broadband-watch-label',
    styleUrls: ['./cbm-broadband-watch-label.scss'],
    templateUrl: './cbm-broadband-watch-label.html',
    standalone: false
})
export class CbmBroadbandWatchLabelComponent implements OnInit, OnDestroy {
    @Input() public currentLine: LineSummary;
    public pageData: CmsDataDetail;
    public labelDetails: CBMLabelSegmentDetails;
    public activePlanId: string;
    public activeTabPlanId: string;
    public broadbandLabelsResponse: BroadbandLabels;
    public labelResponse: NutritionLabel[] = [];
    public inUseIcon: MediaImageOptions;
    public cbmLabelContent: CBMLabelDetails;
    public isGrandFatheredLabel: boolean = false;
    public planList: LabelTabDetail[] = [];
    public availableTabs: LabelTabDetail[] = [];
    public infoIconGrey: MediaImageOptions;

    private xmStore: XmStore;
    private subscriptions: Subscription[] = [];

    constructor(xmStore: XmStore, cimaCore: CimaCore) {
        Object.assign(this, { xmStore, cimaCore });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<User>(User), (user: User) => {
            this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsDataDetail>(CmsDataDetail), (pageData: CmsDataDetail) => {
                this.pageData = pageData;
                this.isGrandFatheredLabel = user.account.level === AccountType.LEVEL_2 || user.account.level === AccountType.LEVEL_3 || user.account.level === AccountType.LEVEL_4;
                this.cbmLabelContent = pageData.cbmBroadbandLabelContent;
                this.labelDetails = pageData.cbmBroadbandLabel.find((label: CBMLabelSegmentDetails) => label.level === user.account.level);
                this.activePlanId = this.currentLine.planId;
            }));
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsCore>(CmsCore), (cms: CmsCore) => {
            this.infoIconGrey = {
                mobile: {
                    base: cms.icons.infoIconBlue
                }
            };
        }));

        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<BroadbandLabels>(BroadbandLabels), ((label: BroadbandLabels) => {
            this.broadbandLabelsResponse = label;
            this.planList = this.labelDetails?.standaloneWatchPlanList;
            this.labelDetails?.standaloneWatchPlanList.forEach((plan: LabelTabDetail) => {
                const foundLabel: NutritionLabel = this.broadbandLabelsResponse.labels.find((nutritionLabel: NutritionLabel) => nutritionLabel.planId === plan.planId);
                if (foundLabel) {
                    this.labelResponse.push(foundLabel);
                    this.availableTabs.push(plan);
                }
            });

            if (this.labelResponse.length > 0) {
                const isActivePlan: boolean = this.labelResponse.some((data: NutritionLabel) => data.planId === this.currentLine.planId);
                this.activeTabPlanId = isActivePlan ? this.currentLine.planId : this.labelResponse[0].planId;
            }
        })));
    }

    public tabChange(planId: string): void {
        this.activePlanId = this.currentLine.planId;
        this.activeTabPlanId = planId;
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }
}
